import { render } from "./my-announcements.vue?vue&type=template&id=beb5c102&scoped=true"
import script from "./my-announcements.vue?vue&type=script&lang=js"
export * from "./my-announcements.vue?vue&type=script&lang=js"

import "./my-announcements.vue?vue&type=style&index=0&id=beb5c102&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb5c102"]])

export default __exports__